<template>

  <div class="container-fluid">


    <div class="row my-4">
      <div v-if="isLoading">
        <Preloader/>
      </div>
      <div class="col-12 mt-3" v-else>
        <h5>پیش بینی اتمام مواد اولیه در یک ماه آینده</h5>
        <small>مواد اولیه: کالاهایی که کالای میانی ندارند و خود کالای میانی هستند</small>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">نام محصول</th>
            <th scope="col" class="text-center">واحد</th>
            <th scope="col" class="text-center">موجودی همه انبارها</th>
            <th scope="col" class="text-center">نیازمندی همه برنامه ها</th>
            <th scope="col" class="text-center">تعداد سفارش خرید</th>
            <th scope="col" class="text-center">تاریخ اتمام</th>
            <th scope="col" class="text-center">تامین</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in rawproductQuantity">
            <td class="text-center">{{item.name}}</td>
            <td class="text-center">{{item.unitName}}</td>
            <td class="text-center">{{item.totalQuantity}}</td>
            <td class="text-center">{{item.totalNeed}}</td>
            <td class="text-center">{{item.totalOrder}}</td>
            <td class="text-center">{{item.reciptDate}}</td>
            <td class="text-center">
              <button class="btn iconed btn-secondary"
                      @click="onTransferClicked(item)"><i
                class="icon-cart-plus"></i><span>دستور خرید-تامین</span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <hr/>
      <div class="col-lg-12 col-12 my-5">
        <div class="card shadow text-white  mb-1">
          <div class="card-body pb-0">
            <div class="card-chart">
              <canvas id="company-product-chart" width="1200" height="400"></canvas>
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-------------------------------------------------------------------------------->
    <b-modal
      ref="selectProductModal"
      title="انتخاب کالا"
      size="xl"
      ok-only
      ok-title="تایید"
      @ok="onSelectProductOk"
    >
      <div ref="productsContainer">
        <products
          :is-select-mode="true"
          @onRowDoubleClicked="openProductDetailModal"
        ></products>
      </div>
    </b-modal>
    <!------------------- MODALS ------------------------------------------------------------->
    <b-modal
      ref="transferModal"
      title="دستور خرید-تامین مواد اولیه"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="transferToWorkstation"
    >
      <div class="row">
        <div class="col-12">
          <label>
            تائید خرید-تامین کالای
            <b>{{trsfProduct}}</b>

          </label>
        </div>
        <div class="col-12 my-3">
          <label>
            تعداد :
          </label>
          <input class="mx-2" v-model="trsfCount" type="number" placeholder="تعداد را وارد کنید"/>
        </div>

      </div>
    </b-modal>


  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState, mapMutations, mapActions} from "vuex";
  import Vue from "vue";
  import Products from "../Products.vue";
  import Moment from "moment-jalali";
  import Utils from "../../_framework/utils/Utils";
  import chart from "chart.js";

  export default {
    name: "inventory-planning",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      Moment,
    },
    data() {
      return {
        isLoading: false,
        show: true,
        nodataProgram: true,
        access: {},
        product: {},
        productQuantity: {},
        productName: "",
        productId: "",
        rawproductQuantity: [],
        rawproducts: {},

        trsfProduct: "",
        trsfCount: 0,
        trsfProductId: 0,
        trsfServeId: 0,
        trsfReciveId: 0,
        trsfReciveName: "",
        trsfUnitId: 0,
        backgroundColor: ["#facf5a8f", "#ff59598f", "#49beb78f", "#a374d58f", "#5d99c68f", "#9cf1968f"],
        hoverBackgroundColor: ['#facf5ab5', '#ff5959b5', '#49beb7b5', '#a374d5b5', '#5d99c6b5', '#9cf196b5'],

      };
    },
    beforeMount() {
      this.getAllRawProductsQuantity();
      this.getOutSourse();
    },
    methods: {
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();

        if (this.$refs && this.$refs.selectProductModal) {


          this.$refs.selectProductModal.show();
        }
        _products.$on("onRowSelect", row => {
          // this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      onSelectProductOk(row) {
        this.hideModal();
      },
      openProductDetailModal(prod) {
        this.product = prod.productName;
        this.productId = prod.id;
        this.hideModal();
        this.getAllProductsQuantity(prod.id)
        // new BaseService('Patterns', '/GetProductPatterns/' + prod.id).getList().then((response) => {
        //   var a = response.data;
        //
        //   if (a.length === 0) {
        //     Utils.handleErrorWithNotification("هیچ الگویی برای این کالا تعریف نشده است", this.$noty);
        //     // console.log("هیچ الگویی برای این کالا تعریف نشده است");
        //   } else {
        //     this.product = prod;
        //     this.productId = prod.id;
        //     this.names = response.data;
        //     this.productPattern = response.data;
        //     console.log(this.productPattern);
        //     this.showPlanningModal = true;
        //     this.$refs.selectProductModal.hide();
        //     this.getPatterns();
        //   }
        // }).catch((error) => {
        //   console.log(error)
        // })
        // this.getKardex(val.id);
      },
      getAllProductsQuantity(id) {
        new BaseService('Planning', '/GetStockProductsQuantity/' + id).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodata = true;
          } else {
            this.nodata = false;
            this.productQuantity = response.data;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      hideModal() {
        this.$refs.selectProductModal.hide();
      },
      getAllRawProductsQuantity() {
        this.isLoading=true;
        new BaseService('Planning', '/GetAllStockProductsQuantity').getList().then((response) => {
          this.isLoading=false;
          this.rawproductQuantity = response.data;
          this.rawproductQuantity.forEach(raw =>
            raw.reciptDate = raw.reciptDate.includes("0001") ? "---" : Moment(raw.reciptDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD")
          );


          let lables = [];
          let needData = [];
          let quantityData = [];
          let orderedData = [];
          let orderData = [];
          let index = 0;
          for (let i = 0; i < this.rawproductQuantity.length; i++) {

            lables.push(this.rawproductQuantity[i].name + "(" + this.rawproductQuantity[i].reciptDate +")");
            needData.push(this.rawproductQuantity[i].totalNeed);
            quantityData.push(this.rawproductQuantity[i].totalQuantity);
            orderedData.push(this.rawproductQuantity[i].totalOrder);
          }


          let data1 = {
            label: 'نیازمندی',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: needData
          };
          index++;
          if (index > 5) index = 0;
          let data2 = {
            label: 'موجودی',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: quantityData
          };
          index++;
          if (index > 5) index = 0;

          let data3 = {
            label: 'سفارش خرید',
            backgroundColor: this.backgroundColor[index],
            hoverBackgroundColor: this.hoverBackgroundColor[index],
            data: orderedData
          };
          index++;
          if (index > 5) index = 0;

          orderData.push(data1);
          orderData.push(data2);
          orderData.push(data3);

          Chart.defaults.global.defaultFontFamily = 'shabnam';
          this.polar = new Chart(document.getElementById("company-product-chart"), {


            // type: 'polarArea',
            type: 'bar',
            data: {
              labels: lables,
              datasets: orderData
            },
            options: {
              // scales: {
              //   xAxes: [{
              //     stacked: true,
              //
              //   }],
              //   yAxes: [{
              //     stacked: true,
              //
              //   }]
              // },
              title: {
                display: true,
                text: 'موجودی، نیاز و سفارش مواد اولیه'
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.7,
                  opacityTo: 0.9,
                  stops: [0, 90, 100]
                }
              },
            }
          })
          // for (let raw of this.rawproductQuantity){
          //   raw.reciptDate = Moment(raw.reciptDate.substring(0, 10), "YYYY-MM-DD").format("jYYYY/jMM/jDD");
          // }
        }).catch((error) => {
          this.isLoading=false;
          console.log(error)
        });
      },
      onTransferClicked(source) {
        this.trsfProduct = source.name;
        this.trsfProductId = source.productId;
        this.trsfUnitId = source.unitId;
        this.trsfCount = source.totalNeed - (source.totalQuantity + source.totalOrder);
        // this.trsfReciveId = source[workIndex].companyId;
        // this.trsfServeId = source[workIndex].companyQuantitys[companyIndex].companyId;
        this.$refs.transferModal.show();
      },
      transferToWorkstation() {
        if (this.trsfCount == 0) {
          Utils.handleErrorWithNotification("تعداد نمیتواند صفر باشد", this.$noty);
        } else {
          this.hideModal();
          let todayDate = new Date();

          todayDate = new Date().toJSON().slice(0, 10);
          todayDate = Moment(todayDate, "YYYY-MM-DD").format("jYYYY/jMM/jDD");

          let data = {
            date: todayDate,
            receiverCompanyId: this.trsfReciveId,
            receiverName: this.trsfReciveName,
            serveOutSourceId: this.trsfServeId,
            serveCompanyId: null,
            serveName: "فروشنده مواد اولیه",
            orders: [{
              deliveryDate: todayDate,
              description: "دستور خرید مواد اولیه",
              productId: this.trsfProductId,
              unitVal: parseInt(this.trsfCount),
              unitId: this.trsfUnitId,
            }],
          };
          console.log(data)
          new BaseService('orders').create(data).then((response) => {
              this.$noty.success("سفارش با موفقیت ثبت شد");
            }
          ).catch((error) => {
            console.log(error)
          })

        }
      },
      getOutSourse() {
        var a ={
          pageIndex:0,
          pageSize:12000
        };
        new BaseService('outsource').getList(a).then((response) => {
            let outSource = response.data.data;
            let find = false;
            let index = 0;
            for (let i = 0; i < outSource.length; i++) {
              if (outSource[i].outSourceName === 'فروشنده مواد اولیه') {
                find = true;
                index = i;
                break;
              }
            }
            if (find) {
              this.trsfServeId = outSource[index].id;
            } else {
              let data = {
                outSourceName: 'فروشنده مواد اولیه'
              };
              new BaseService('outsource').create(data).then((response) => {
                  // g(response.data);
                  this.trsfServeId = response.data.id;
                }
              ).catch((error) => {
                console.log(error)
              })
            }
            console.log(this.trsfServeId);
          }
        ).catch((error) => {
          console.log(error)
        });
        new BaseService('company').getList().then((response) => {
            this.trsfReciveId = response.data[0].id;
            this.trsfReciveName = response.data[0].companyName;
          }
        ).catch((error) => {
          console.log(error)
        })
      },


    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
